"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PIAConfig = void 0;
var _piaThemeContext = require("./piaThemeContext");
var _piaQuoteToolContext = require("./quoteTools/piaQuoteToolContext");
var _piaSuccess = require("./quoteTools/piaSuccess");
var _defaultIcons = require("../../defaults/productTable/defaultIcons");
var _defaultOptionalInclusions = require("../../defaults/productTable/staff/defaultOptionalInclusions");
var _defaultStaffInstructions = require("../../defaults/productTable/staff/defaultStaffInstructions");
var _defaultAuthorisedPersonDisplaySettings = require("../../defaults/quoteTools/defaultAuthorisedPersonDisplaySettings");
var _defaultCustomRouteDefinitions = require("../../defaults/quoteTools/defaultCustomRouteDefinitions");
var _defaultRegularVetDisplaySettings = require("../../defaults/quoteTools/defaultRegularVetDisplaySettings");
var _defaultStaffContext = require("../../defaults/quoteTools/staff/defaultStaffContext");
var _piaSummary = require("./quoteTools/piaSummary");
var _defaultPayment = require("../../defaults/quoteTools/defaultPayment");
var _defaultStepDefinitions = require("../../defaults/quoteTools/defaultStepDefinitions");
var _astiaBrandContext = require("./themes/astia/astiaBrandContext");
var _piaStepDefinitions = require("./quoteTools/piaStepDefinitions");
var _piaCustomRouteDefinitions = require("./quoteTools/piaCustomRouteDefinitions");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var quoteTools = {
  themeOverrides: _piaQuoteToolContext.PIAQuoteToolContext,
  steps: {
    StepDefinitions: _piaStepDefinitions.PIAStepDefinitions,
    basicOwnerDetails: _piaQuoteToolContext.PIAAboutOwner,
    fullOwnerDetails: _piaQuoteToolContext.PIAFullOwnerDetails,
    aboutPet: _piaQuoteToolContext.PIAAboutPet,
    coverDisplayOptions: _piaQuoteToolContext.PIACoverDisplayOptions,
    summary: _piaSummary.PIASummary,
    success: _piaSuccess.PIASuccess,
    payment: _defaultPayment.defaultPayment,
    bannerStyle: 'bullets',
    showCompletedStepBannerOnPage: 'success'
  },
  widgets: {
    authorisedPersonDisplaySettings: _defaultAuthorisedPersonDisplaySettings.defaultAuthorisedPersonDisplaySettings,
    regularVetDisplaySettings: _defaultRegularVetDisplaySettings.defaultRegularVetDisplaySettings
  },
  customRouteDefinitions: _piaCustomRouteDefinitions.PIACustomRouteDefinitions,
  staffModeContext: _defaultStaffContext.DefaultStaffModeContext,
  productTable: {
    optionalInclusions: _defaultOptionalInclusions.DefaultOptionalInclusions,
    staffInstructions: _defaultStaffInstructions.DefaultStaffInstructions,
    icons: _defaultIcons.defaultIcons
  },
  // TODO: Update this to the actual value. Below is added for the test purpose only.
  middlewareApiKeys: {
    "public": {
      sit: {
        applicationId: '1BFB7E47-3488-4793-8161-18D90D29C087',
        apiKey: '2VD61B46EF909D40749',
        expiry: 3600
      },
      uat: {
        applicationId: '1BFB7E47-3488-4793-8161-18D90D29C087',
        apiKey: '2VD61B46EF909D40749',
        expiry: 3600
      },
      preprod: {
        applicationId: '330DEA3E-0A77-40AE-88AD-8F91026DDC20',
        apiKey: '81904FB7F31A4837A9',
        expiry: 3600
      },
      prod: {
        applicationId: 'A244829A-EB70-4C8F-B1D0-2C7F9C72D41F',
        apiKey: '3FA2A9BB331E447E99',
        expiry: 3600
      }
    }
  },
  recaptchaSiteKey: '6LdcGGEhAAAAAOZsWjeldFLxZaiWgheJUiqInN3A',
  recaptchaSecretKey: '6LdcGGEhAAAAAGZxA7skR01ZlXWgALcRNfjXPpnM',
  recaptchaSiteKeyProd: '6LdMW2YhAAAAAOU-dn_FUkdnAzJ0tO9Fv0gyRzOE',
  recaptchaSecretKeyProd: '6LdMW2YhAAAAAJkaIotboLHMHeK6mXinZ0unrjwA'
};
var PIAConfig = exports.PIAConfig = {
  theme: _objectSpread(_objectSpread({}, _piaThemeContext.PIAThemeContext), {}, {
    brand: _objectSpread(_objectSpread({}, _piaThemeContext.PIAThemeContext.brand), {}, {
      broker: 'PIA',
      brokers: {
        astia: {
          theme: _astiaBrandContext.AstiaBrandContext,
          quoteTools: _objectSpread(_objectSpread({}, quoteTools), {}, {
            themeOverrides: _astiaBrandContext.AstiaQuoteToolContext
          })
        }
      }
    })
  }),
  quoteTools: quoteTools
};